import React from "react";
import {
	Button,
	Dialog,
	DialogContent,
	DialogActions,
} from "../../common/MaterialComponent";
import { useGetComponentStringsContext } from "../../hooks/useGetComponentStrings";
import { ButtonPrimary } from "../../common/sharedStyle";
export interface DialogProps {
	open: boolean;
	message: string;
	closeDialog: (deleteBtnPressed?: boolean) => void;
	positiveActionText?: string;
	negativeActionText?: string;
}

export const ConfirmationDialog: React.FC<DialogProps> = ({
	open,
	message,
	closeDialog,
	positiveActionText,
	negativeActionText,
}) => {
	const strings = useGetComponentStringsContext().Shared;

	return (
		<div data-testid="confirmation-dialog">
			<Dialog open={open}>
				<DialogContent dividers>{message}</DialogContent>
				<DialogActions>
					<Button onClick={() => closeDialog()} className="cancelBtn">
						{negativeActionText ? negativeActionText : strings.cancelButtonText}
					</Button>
					<ButtonPrimary
						onClick={() => closeDialog(true)}
						className="deleteBtn"
					>
						{positiveActionText ? positiveActionText : strings.deleteButtonText}
					</ButtonPrimary>
				</DialogActions>
			</Dialog>
		</div>
	);
};
